<template>
  <section class="side-bar-overlay">
    <div class="side-bar p-3" click-outside="$emit('close')">


    </div>
  </section>
</template>
<script>
export default {
  props: {
    loggedInUser: Object,
    showLogin: Boolean,
    placeholder: String,
    user: Object,
    notifications: {
      type: Array,
      default: () => []
    },
    business: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return {
      searchDetails: ''
    }
  },
  methods: {
    isUrl(){}
  },
  watch: {
    searchDetails(){
      this.$emit('search', this.searchDetails)
    }
  }
}
</script>
<style scoped lang="scss">
.side-bar{
  width: 80vw;
  background: white;
  height: 100vh;
  z-index: 99999999999999;
  &-overlay{
    height: 100vh;
    width: 100vw;
    position: fixed;
    left: 0;
    background: rgba(15, 62, 88, 0.5);
    z-index: 999999999999;
  }
}
.nav {
  height: 86px;
  margin: 0 100px;
  &-container-bell {
    margin-right: -4rem;
  }
  &-wrapper {
    margin-top: -2rem;
  }
  &-cover {
    margin-bottom: -0.7rem;
  }
  &-biz-aid {
    width: 160px;
  }
  &-dropdown {
    border: none;
    box-shadow: 0px 15px 15px rgba(0, 0, 0, 0.05);
    top: 2rem !important;
  }
  &-logo {
    width: 140px;
  }
  &-user {
    width: 54px;
    height: 54px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-btn {
    width: 149px;
    height: 37px;
  }
  &-notification {
    width: 42px;
    height: 42px;
    background: #F2F2F2;
    &-icon {
      width: 22px;
      height: 18px;
      background: #B64949;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 30px;
      top: -0.3rem;
      right: -0.3rem;
    }
  }
}

</style>
